import Service, { getCallApiFunction } from '../service'
// import denormalizer from './denormalizer'
// import normalizer from './normalizer'

type DataType = {
  roomId: string
}

class SetUserInApi extends Service {
  constructor(data: DataType) {
    super()
    this.name = 'SET_USER_IN'

    this.config = {
      url: `/v1/room/user-in`,
      method: 'POST',
      data,
    }
  }
}

export const setUserIn = (data: DataType) => getCallApiFunction(new SetUserInApi(data))
